var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.componentContent.categoryShow || _vm.canShow,
          expression: "componentContent.categoryShow || canShow"
        }
      ],
      staticClass: "classification"
    },
    [
      _c(
        "ul",
        _vm._l(_vm.componentContent.category, function(item, index) {
          return _c("li", { key: index, style: _vm.liStyle }, [
            _c(
              "div",
              {
                on: {
                  mouseleave: function($event) {
                    _vm.showClassify = false
                  },
                  mouseenter: function($event) {
                    return _vm.iscategoryName(item.categoryName)
                  }
                }
              },
              [
                _c("div", { staticClass: "item" }, [
                  _vm.getIconUrl(item.id)
                    ? _c("img", {
                        attrs: { src: _vm.getIconUrl(item.id), alt: "" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticStyle: { cursor: "pointer" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.jumpCategory(
                            Object.assign({}, item, {
                              rootName: item.categoryName
                            })
                          )
                        }
                      }
                    },
                    [_vm._v(_vm._s(item.categoryName))]
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "hoverBox",
                class: { canScroll: item.childs.length > 6 },
                staticStyle: { display: "none" }
              },
              _vm._l(item.childs, function(subItem) {
                return _c("div", { key: subItem.id, staticClass: "dl" }, [
                  _c(
                    "div",
                    {
                      staticClass: "dt",
                      staticStyle: { cursor: "pointer" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.jumpCategory(
                            Object.assign({}, subItem, {
                              rootName: item.categoryName
                            })
                          )
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(subItem.categoryName) +
                          "\n          "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "dd" },
                    _vm._l(subItem.childs, function(threeItem) {
                      return _c(
                        "a",
                        {
                          key: threeItem.id,
                          staticClass: "a-link",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.jumpCategory(
                                Object.assign({}, threeItem, {
                                  rootName: item.categoryName
                                })
                              )
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(threeItem.categoryName) +
                              "\n            "
                          )
                        ]
                      )
                    }),
                    0
                  )
                ])
              }),
              0
            )
          ])
        }),
        0
      ),
      _vm._v(" "),
      _vm.showClassify && _vm.$route.name == "index"
        ? _c(
            "div",
            {
              class:
                _vm.showClassify && _vm.$route.name == "index"
                  ? "showClassify"
                  : "showClassify other",
              on: {
                mouseleave: function($event) {
                  _vm.showClassify = false
                },
                mouseenter: function($event) {
                  _vm.showClassify = true
                }
              }
            },
            _vm._l(_vm.componentContent.category, function(item, index) {
              return _c(
                "div",
                { key: index },
                _vm._l(item.childs, function(subItem, index) {
                  return _vm.flag == item.categoryName
                    ? _c("div", { key: index, staticClass: "category" }, [
                        _c(
                          "div",
                          {
                            key: subItem.id,
                            staticClass: "twocategory",
                            staticStyle: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.jumpCategory(
                                  Object.assign({}, subItem, {
                                    rootName: item.categoryName
                                  })
                                )
                              }
                            }
                          },
                          [_vm._v(_vm._s(subItem.categoryName))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "threecategory" },
                          _vm._l(subItem.childs, function(Item2, index) {
                            return _c(
                              "span",
                              {
                                key: index,
                                staticStyle: { cursor: "pointer" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.jumpCategory(
                                      Object.assign({}, Item2, {
                                        rootName: item.categoryName
                                      })
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n          " + _vm._s(Item2.categoryName)
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ])
                    : _vm._e()
                }),
                0
              )
            }),
            0
          )
        : _vm.$route.name != "index"
        ? _c(
            "div",
            {
              class:
                _vm.showClassify && _vm.$route.name == "index"
                  ? "showClassify"
                  : "showClassify other",
              on: {
                mouseleave: function($event) {
                  _vm.showClassify = false
                },
                mouseenter: function($event) {
                  _vm.showClassify = true
                }
              }
            },
            _vm._l(_vm.componentContent.category, function(item, index) {
              return _c(
                "div",
                { key: index },
                _vm._l(item.childs, function(subItem, index) {
                  return _vm.flag == item.categoryName
                    ? _c("div", { key: index, staticClass: "category" }, [
                        _c(
                          "div",
                          {
                            key: subItem.id,
                            staticClass: "twocategory",
                            staticStyle: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.jumpCategory(
                                  Object.assign({}, subItem, {
                                    rootName: item.categoryName
                                  })
                                )
                              }
                            }
                          },
                          [_vm._v(_vm._s(subItem.categoryName))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "threecategory" },
                          _vm._l(subItem.childs, function(Item2, index) {
                            return _c(
                              "span",
                              {
                                key: index,
                                staticStyle: { cursor: "pointer" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.jumpCategory(
                                      Object.assign({}, Item2, {
                                        rootName: item.categoryName
                                      })
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n          " + _vm._s(Item2.categoryName)
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ])
                    : _vm._e()
                }),
                0
              )
            }),
            0
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-708fa6f8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-708fa6f8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/canvasShow/cereshop/pc/classification.vue
// module id = null
// module chunks = 